/**
 * Vue Dictonary v0.0.1
 * https://github.com/cmp-cc/vue-cookies
 *
 * Copyright 2016, cmp-cc
 * Released under the MIT license
 */

(function () {

 
    var obj;
    const dictonary = {
        // install of Vue
        currentLanguage: 0,
        languages: [ 'englisch', 'deutsch' ],
        dict: [
            ['ok', 'okay'],
            ['cancel', 'abbrechen'],


        ],
        install: function (Vue) {
            obj = this
            Vue.prototype.$dictonary = this;
            Vue.$dictonary = this;
            Vue.prototype.$translate = this.translate
            Vue.$translate = this.translate
        },
        clean(key){
            return key.replace(/[:|;|,]/g,  '')
        },
        translate(key){
            if(!obj.currentLanguage)
                return key
            const cleanedWord = obj.clean(key)
            const word = obj.dict.find(e => e[0] == cleanedWord)
            if(word)
                return key.replace(cleanedWord, word[obj.currentLanguage])
            else{
                if (process.env.MODE != 'production')
                    console.log('Translation for ' + cleanedWord + ' missing');
                return key
            }
        },
        add: function (word) {
            if (!Array.isArray(word[0]))
                word = [word]
            word.forEach(w => {
                if(!obj.dict.some(e => e[0] == w[0]))
                    obj.dict.push(w)
            });
        },
     
    };

    if (typeof exports == 'object') {
        module.exports = dictonary;
    } /*else if (typeof define == 'function' && define.amd) {
        define([], function () {
            return dictonary;
        });
    } */else if (window.Vue) {
        window.Vue.use(dictonary);
    }
    if (typeof window !== 'undefined') {
        window.$dictonary = dictonary;
    }

})();
